const links = {
	// internal links
	home: "/",
	blog: "/blog",
	about: "/about",
	contact: "/contact",
	privacy: "/privacy",
	terms: "/terms",
	brokers: "/brokers",
	// first party links
	getStarted: "https://www.arlohealth.com/get-started",
	signin: "https://accounts.joinarlo.com/sign-in",
	// third party links
	linkedin: "https://www.linkedin.com/company/arlo-health/",
	mailto: "mailto:quotes@joinArlo.com",
	careers: "https://jobs.gem.com/arlo",
} as const

export default links
